import { IS_STORE_ROOT } from '@/constants';
import { SCHEDULE_UPDATE_CELL } from '@/constants/undoActions';

const MAX_UNDO_ACTIONS = 30;

/**
 * See createUndoAction() in ./helpers.js for UndoAction structure.
 * This array stores either UndoAction Objects or Arrays of them.
 *
 * Example: [UndoAction, [UndoAction, UndoAction], UndoAction]
 * - On Undo, the singular UndoAction affects one cell
 * - Undoing an array handles multiple actions at once with one 'ctrl+z'
 */
export const actions = {
  appendUndoStep({ commit, state }, payload) {
    const { undoActions } = state;
    const newUndoActions = [...undoActions, payload];
    const limitedUndoActions = newUndoActions.slice(-MAX_UNDO_ACTIONS);
    commit('setUndoActions', limitedUndoActions);
  },
  async undoHandleAction({ dispatch, commit, getters, rootState }) {
    const { lastUndoAction } = getters;
    if (!lastUndoAction) {
      return;
    }
    dispatch('setLastUndoAction', lastUndoAction);
    const isMultipleActions = Array.isArray(lastUndoAction);

    commit('setIsUndoing', true);
    commit('openSnackBar', {
      // Show snackbar longer because undo needs to be delayed if updateCell is slow. Manual close later.
      timeout: 10000,
      text: `Undoing change to "${isMultipleActions ? 'multiple columns' : lastUndoAction.col}"...`,
    }, IS_STORE_ROOT);

    try {
      const actions = isMultipleActions ? lastUndoAction : [lastUndoAction];
      dispatch('removeTheLastUndoAction');
      await Promise.all(actions.map(async ({ action, ...payload } = {
      }) => {
        await waitForColUpdate(rootState, payload.projectId, payload.col);
        return await dispatch(action, {
          ...payload,
          isUndoAction: true,
        }, IS_STORE_ROOT);
      }));
    } finally {
      commit('closeSnackBar', null, IS_STORE_ROOT);
      commit('setIsUndoing', false);
    }
  },
  removeTheLastUndoAction({ commit, state }) {
    commit('setUndoActions', state.undoActions.slice(0, -1));
  },
  setLastUndoAction({ commit, dispatch }, payload) {
    dispatch('manageSelectedCells', payload);
    commit('setLastUndoAction', payload);
  },
  manageSelectedCells({ dispatch }, lastUndoAction) {
    const actions = Array.isArray(lastUndoAction) ? lastUndoAction : [lastUndoAction];
    actions.reverse().forEach(item => {
      const { row, col, action } = item || {
      };
      if (action === SCHEDULE_UPDATE_CELL) {
        const rowId = row?.rowId;
        dispatch('ProjectDetailsTableSchedule/setSelectedCells', [{
          col,
          rowId,
        }], IS_STORE_ROOT);
      } else {
        dispatch('ProjectDetailsTableSchedule/setSelectedCells', [], IS_STORE_ROOT);
      }
    });
  },
};

const WAIT_TIME = 300;
const MAX_COUNT = 10;

async function waitForColUpdate(rootState, projectId, col) {
  let waitCount = 0;
  while (rootState?.ScheduleRows?.updatingCols[projectId]?.[col] && waitCount < MAX_COUNT) {
    await new Promise(r => setTimeout(r, WAIT_TIME));
    waitCount += 1;
  }
}